"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutopayReference = void 0;
const common_1 = require("../common");
/**
 * @deprecated - Use common/entity-reference
 */
exports.AutopayReference = common_1.EntityReference;
//# sourceMappingURL=autopay-reference.js.map